import { trailerTypesById } from "features/loads/enums";

// Matches the LoadMovementMethod enum on the API
export const loadMovementMethodsById = {
    DRIVEN: 1,
    TOWED_HAULED: 2
};

// A load with no trailer type defaults to TO_BE_DRIVEN on submit (CreateLoadGroup),
// so an unset trailer type prices as a driven move
export const getMovementMethodFromTrailerType = (trailerType) =>
    !trailerType || trailerType === trailerTypesById.TO_BE_DRIVEN
        ? loadMovementMethodsById.DRIVEN
        : loadMovementMethodsById.TOWED_HAULED;
